import React from "react";
import { Modal } from "@mui/material"; 
import Box from "@mui/material/Box";
import { RxCrossCircled } from "react-icons/rx"; 
import SuccessBackground from "../../../../asesst/SuccessBackground.svg";
import Tick from "../../../../asesst/tick.svg";

const SuccessMasterModal = ({ open, title, message, onClose }) => {
  return (
    <Modal open={open} className="justify-center items-center">
      <Box className="bg-white text-center p-6 rounded-2xl shadow-md max-w-lg mx-auto my-20">
        <RxCrossCircled
          onClick={onClose}
          className="float-end top-2 h-6 w-6 cursor-pointer"
        />
        <div className="text-center inline-flex mt-8">
          <div
            className="w-[72px] h-[72px] flex items-center justify-center"
            style={{ backgroundImage: `url(${SuccessBackground})` }}
          >
            <img src={Tick} alt="Success" className="w-7 h-7" />
          </div>
        </div>
        <p className="text-3xl text-[#0B0B0B] font-semibold mt-4 mb-4">
          {title}
        </p>
        <span className="text-[#6D6D6D]">{message}</span>
        <div className="mt-6 flex justify-center gap-4">
          <button
            onClick={onClose}
            className="border border-inherit px-4 py-2 rounded-lg"
          >
            Close
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default SuccessMasterModal;